import React from "react";
import { NodeProps, useReactFlow } from "reactflow";
import { operationType } from "../../../../../services/types";
import { Main, Styled } from "./style";
import { Select } from "../../../../form/select";
import { updateNodeValue } from "../../../../../services/method";
import axios from "axios";
import { webURL } from "../../../../../services/API";
import { SettingsBlock, settingsDataType } from "../../../../settingsBlock";
import { IoWarningOutline } from "react-icons/io5";
import { ExpandedBlock } from "../../../expanded";
import { TextInput } from "../../../../form/textInput";
import { useSearchParams } from "react-router-dom";

type KnowledgeProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

export function SubWorkflow({ id, data, setChildMinimize, setChildSettings }: KnowledgeProps) {
   const [searchParams] = useSearchParams();
   const { setNodes } = useReactFlow();
   const workflowId = React.useMemo(() => data.value?.workflows?.find((workflow: any) => workflow.isActive)?.id, [data.value?.workflows]);
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);

   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   // ---
   React.useEffect(() => {
      (async function() {
         const response = (await axios.get(`${webURL}/projects?select=name`)).data;
         updateNodeValue(id, setNodes, { 
            workflows: response.filter((i: any) => i._id !== searchParams.get('id')).map((item: any, index: number) => ({ 
               id: item._id, name: item.name, 
               isActive: workflowId ? workflowId === item._id : index === 0 
            })) 
         });
      })();
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   // ---
   const handleSelectWorkflow = (selectId: number) => {
      updateNodeValue(id, setNodes, { workflows: data.value?.workflows.map((item: any) => ({ ...item, isActive: item.id === selectId })) });
   }
   // ---
   const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>, keyRef?: string) => {
      const value = e.target.value;
      if (keyRef) updateNodeValue(id, setNodes, { [keyRef]: value });
   }

   // ---
   const isWarning = false;

   return (<>
      <SettingsBlock nodeId={ id }data={ settings } setData={ setSettings } />
      <Main>
         { isWarning ? <>
            <div id="warning"></div>
            <span id="warningIcon"><IoWarningOutline size={ 21 } /></span>
         </> : null }
         { isExpanded ? <ExpandedBlock
            data={{ id, ...data }} 
            handleClose={ () => setIsExpanded(false) } 
            isWarning={ isWarning }
            style={{ width: '400px' }}
         ><Styled>
            <Select title="Workflow" data={ data.value?.workflows || [] } handleSelectItem={ handleSelectWorkflow } isSmall={ true } />
            <div className="line"><span>Or import workflow</span></div>
            <TextInput keyRef="workflow_id" placeholder="Workflow ID" value={ data.value?.workflow_id || '' } handleChange={ e => handleChangeInput(e, 'workflow_id') } />
            <TextInput keyRef="api_key" placeholder="Authorization (API Key)" value={ data.value?.api_key || '' } handleChange={ e => handleChangeInput(e, 'api_key') } />
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}